export const DURATION = "duration";
